import LayoutPadrao from '../layouts/LayoutPadrao.vue'
import ListaUsuariosView from '@/views/usuarios/ListaUsuariosView.vue'
import UsuarioFormView from '@/views/usuarios/UsuarioFormView.vue'
import UsuariosOnlineView from '@/views/usuarios/UsuariosOnlineView.vue'

// Auth check function
const isAuthenticated = (to, from, next) => {
  const isLoggedIn = localStorage.getItem('user') !== null
  if (isLoggedIn) next()
  else next('/login')
}

export default {
  path: '/',
  component: LayoutPadrao,
  beforeEnter: isAuthenticated,
  children: [
    {
      path: 'usuarios',
      name: 'usuarios',
      component: ListaUsuariosView,
      meta: { 
        requiresAuth: true,
        title: 'Lista de Usuários',
        nome_fisico: 'usuarios'
      },
    },
    {
      path: '/usuarios/form/:id?',
      name: 'UsuarioForm',
      component: UsuarioFormView,
      props: true,
      meta: { 
        requiresAuth: true, 
        title: 'Editar Usuário',
        nome_fisico: 'usuarios'
      },
    },
    {
      path: '/usuarios-online',
      name: 'usuarios-online',
      component: UsuariosOnlineView,
      meta: { 
        requiresAuth: true,
        title: 'Usuários Online',
        nome_fisico: 'usuarios'
      },
    },
  ],
}
